export default __webpack_public_path__ + "static/media/i1.a5f55dfc.png";